import { Injectable } from '@angular/core';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class AuthenticationAnalyticsService {
  constructor() {}

  analyticAuthenticationVerifyStarted() {
    gtag('event', 'authentication_verify_started', {
      event_category: 'Authentication Events',
    });
  }

  analyticAuthenticationCodeVisited() {
    gtag('event', 'authentication_code_visited', {
      event_category: 'Authentication Events',
    });
  }

  analyticAuthenticationVerifyCompleted() {
    gtag('event', 'authentication_verify_completed', {
      event_category: 'Authentication Events',
    });
  }

  analyticAuthenticationRegisterStarted() {
    gtag('event', 'authentication_register_started', {
      event_category: 'Authentication Events',
    });
  }

  analyticAuthenticationRegisterCompleted() {
    gtag('event', 'authentication_register_completed', {
      event_category: 'Authentication Events',
    });
  }
}
